import { render } from "./lc.vue?vue&type=template&id=062e4605&scoped=true"
import script from "./lc.vue?vue&type=script&lang=js"
export * from "./lc.vue?vue&type=script&lang=js"

import "./lc.vue?vue&type=style&index=0&id=062e4605&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062e4605"]])

export default __exports__